module.exports = __webpack_public_path__ + "files/026b3225cd942cdf530f833d717f636a.png";